/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Reply_SubmitInputs */

const en_settings_tickets_reply_submit = /** @type {(inputs: Settings_Tickets_Reply_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send Reply`)
};

/**
* | output |
* | --- |
* | "Send Reply" |
*
* @param {Settings_Tickets_Reply_SubmitInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_reply_submit = /** @type {((inputs?: Settings_Tickets_Reply_SubmitInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Reply_SubmitInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_reply_submit(inputs)
});
export { settings_tickets_reply_submit as "settings.tickets.reply_submit" }